import * as actionTypes from "./actionTypes";

export const showLoader = (payload) => ({
    type: actionTypes.SHOW_LOADER,
    payload
});
export const hideLoader = () => ({
    type: actionTypes.HIDE_LOADER,
});
export const showError = (error, variant, icon) => ({
    type: actionTypes.SHOW_ERROR,
    payload: { error, variant, icon },
});
export const hideError = () => ({
    type: actionTypes.HIDE_ERROR,
});
